import { handleRoute } from "../https";

export async function getBenefitDetails({
  companyId,
  category,
  vendorId,
  query,
}) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/benefits/categories/${category}/${vendorId}?${query}`,
  });
  return res;
}

export async function editBenefitConfig({
  companyId,
  benefitModelId,
  category,
  benefitConfigId,
  payload,
}) {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/benefit-models/${benefitModelId}/categories/${category}/benefit-configs/${benefitConfigId}`,
    payload,
  });
  return res;
}
